module.exports = Ember.Component.extend({
    normalizedAmount: function() {
        var normalValue = this.get('entry.properties.details.value') / 100
        var currency = this.get('entry.properties.details.currency')
        return Billy.money(normalValue, currency, '0,0.[00]')
    }.property('entry.properties.details.{value,currency}')
})
